import {
  useWSModalCustom,
  WSModal,
  WSModalCustomProps,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import { useHistory } from "react-router-dom";
import { PATH_ONBOARDING_TAX_WITHHOLDINGS } from "../../Onboarding";

type Props = {
  onPauseReminders: () => void;
} & WSModalCustomProps<void>;

export const ModalDismissTaxWithholdingsSetup: React.FC<Props> = ({
  onPauseReminders,
  ...modalProps
}) => {
  const history = useHistory();

  return (
    <WSModal
      title="Tax withholdings setup"
      size="M"
      actions={{
        alignment: "fill",
        buttons: [
          {
            label: "Pause reminders for now",
            onClick: () => {
              onPauseReminders();
              modalProps.onClose();
            },
            kind: "Tertiary"
          },
          {
            label: "Complete your setup",
            onClick: () => {
              modalProps.onClose();
              history.push(PATH_ONBOARDING_TAX_WITHHOLDINGS);
            },
            kind: "Secondary"
          }
        ]
      }}
      {...modalProps}
    >
      <WSText.ParagraphSm mb="L">
        We’ve noticed you haven’t completed your tax withholdings setup. Avoid
        surprises at tax time by setting up your <b>tax withholdings</b> today
        to stay financially prepared.
      </WSText.ParagraphSm>

      <WSText.ParagraphSm>
        <b>Not the right time?</b> If you prefer to handle taxes on your own or
        have another reason for not setting up tax withholdings, pause reminder
        for now and let us know your feedback.
      </WSText.ParagraphSm>
    </WSModal>
  );
};

export const useModalDismissTaxWithholdingsSetup = () =>
  useWSModalCustom(ModalDismissTaxWithholdingsSetup);
